const rolDe = (client) => (client?.rol || "").toLowerCase();

export const esVendedor = (client) => rolDe(client) === "vendedor";

const identidadDe = (client) => {
  const usuarioGuardado =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("userAdminMake") || ""
      : "";
  return `${client?.username || ""} ${client?.email || ""} ${usuarioGuardado}`.toLowerCase();
};

// Plan lector queda en el rol Vendedor del JSON histórico, pero solo Andrea
// debe verlo. El resto de vendedores queda fuera aunque conserve esas llaves.
export const puedeVerPlanLector = (client) => {
  if (!esVendedor(client)) return true;
  return identidadDe(client).includes("andrea");
};

// Las listas de actividades, guías y videos se consultan con ver_actividades.
// Un vendedor que ya puede ver libros también puede abrirlas, sin heredar
// crear, editar, eliminar ni los reportes.
export const puedeVerListasActividades = (access, client) =>
  Boolean(
    access?.ver_actividades || (esVendedor(client) && access?.ver_libros),
  );

// El vendedor autoriza paquetes de libros, pero no administra acceso ni paquetes de videos.
export const puedeVerAccesoVideos = (access, client) => {
  if (esVendedor(client)) return false;
  return Boolean(
    access?.editar_actividad ||
      access?.ver_actividades ||
      access?.autorizar_paquete_cliente,
  );
};
